/* eslint-disable import/prefer-default-export */
/* eslint-disable no-underscore-dangle */

const COLORS = {
  black: '#000000',
  blackLight: '#3C3C3B',
  white: '#FFFFFF',
  grey: '#484848',
  grey1: '#B4B4B4',
  greyLight: '#C9C9C9',
  greyBlueLight: '#E6ECF2',
  greyLighter: '#E1E1E1',
  brown: '#B78346',
  brownLight: 'rgba(212, 171, 122, 0.7)',
  maroon: '#783922',
  maroonLight: '#A26057',
  blue: '#006DAA',
  blueLight: '#7CA7BF',
  blueLighter: '#7CA7BF',
  transparent: 'transparent',
  gridFill: '#f3f6f9',
  unit0rooms: '#E82425',
  unit1rooms: '#006DAA',
  unit2rooms: '#FF8081',
  unit3rooms: '#082B5A',
  unitLarge: '#374C59',
  unit0rooms_excel: '#f17a7c',
  unit1rooms_excel: '#98c4dc',
  unit2rooms_excel: '#ffc7c8',
  unit3rooms_excel: '#7084a0',
  unitLarge_excel: '#bac3c8',
  view3D_externalWindowWall: 0x9DC0D5,
  view3D_externalWall: 0xD0D9E2,
  view3D_background: 0xEEF5F9,
  view3D_edge: 0x93A1AD,
  view3D_roof: 0xE6F0F4,
  // Massing editor
  massingEditor_residential: [
    '#EDF9FF',
    '#CEE7F4',
    '#ACDEFA',
    '#D0E4FB',
    '#CCD7F3',
  ],
  massingEditor_commercial: ['#FFD6D6', '#FFE5E5'],
  massingEditor_cellar: ['#D2DDE8'],
  massingEditor_subCellar: [
    '#BFCCD9',
  ],
  /**
   * If you added a new color,
   * Please add it to the src/index.css :root variable
   */
};

export const appStyle = {
  colors: {
    ...COLORS,
    canvasModalBackground: COLORS.greyBlueLight,
    onHoverColor: COLORS.maroonLight,
    snapGridLineColor: '#006daa',
    snapGridLineColorLighter: '#0096e9',
  },
  arrow: {
    fill: COLORS.blackLight,
    onHoverFill: COLORS.grey,
    circleRadius: 25,
  },
  core: {
    selected: {
      fill: COLORS.blueLight,
      opacity: 1,
    },
    unSelected: {
      fill: '#dadddf',
      opacity: 0.45,
    },
  },
  grid: {
    fill: COLORS.gridFill,
    strokeColor: COLORS.greyBlueLight,
    strokeWidth: 1,
  },
  external: {
    strokeColor: COLORS.blackLight,
    strokeWidth: 9,
  },
  externalWindowWall: {
    fill: COLORS.gridFill, // externalWindowWall is 4 black lines, the fill is to achieve transparent effect
    strokeColor: COLORS.blackLight,
    strokeWidth: 9,
  },
  staircase: {
    wall: {
      strokeColor: COLORS.blackLight,
      strokeWidth: 4.5,
    },
  },
  serviceRoom: {
    wall: {
      strokeColor: COLORS.blackLight,
      strokeWidth: 4.5,
    },
  },
  externalWall: {
    fill: COLORS.blackLight,
    strokeColor: COLORS.blackLight,
    strokeWidth: 9,
    onHoverFill: COLORS.grey,
  },
  unitWall: {
    fill: COLORS.blackLight,
    strokeColor: COLORS.blackLight,
    strokeWidth: 3,
    onHoverFill: COLORS.grey,
  },

  corridor: {
    wall: {
      strokeColor: COLORS.blackLight,
      strokeWidth: 4.5,
    },
  },
  elevator: {
    wall: {
      strokeColor: COLORS.blackLight,
      strokeWidth: 4.5,
    },
  },
  roomBeforeResult: {
    strokeColor: COLORS.white,
    strokeWidth: 4.5,
    fill: COLORS.blueLight,
    fillSelected: COLORS.blue,
  },
  trashRoom: {
    wall: {
      strokeColor: COLORS.blackLight,
      strokeWidth: 4.5,
    },
    fill: COLORS.grey1,
  },
};
